import { motion, useReducedMotion } from 'motion/react';
import { RevealOnScroll } from './motion/RevealOnScroll';

export function CtaBand() {
  const reduce = useReducedMotion();

  return (
    <section className="px-4 sm:px-6 lg:px-8 py-24">
      <RevealOnScroll className="relative mx-auto max-w-5xl overflow-hidden rounded-3xl border border-white/10 px-6 py-20 text-center">
        <div aria-hidden="true" className="absolute inset-0 -z-10 bg-zinc-900" />
        <div
          aria-hidden="true"
          className="absolute inset-0 -z-10"
          style={{
            background:
              'radial-gradient(ellipse 85% 100% at 50% 100%, rgba(99,102,241,0.35), transparent 65%)',
          }}
        />
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Ready to let AI chase your emails?</h2>
        <p className="text-lg text-zinc-400 mb-8">
          Start using Chase it for me today. Just CC us and watch it work.
        </p>
        <motion.a
          href="/app"
          whileHover={reduce ? undefined : { scale: 1.03 }}
          whileTap={reduce ? undefined : { scale: 0.97 }}
          className="inline-block px-8 py-3 bg-indigo-600 text-white rounded-lg text-lg font-semibold hover:bg-indigo-500 transition-colors shadow-lg shadow-indigo-600/30"
        >
          Get Started
        </motion.a>
      </RevealOnScroll>
    </section>
  );
}
